import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as articlesActions from '../../actions/articlesActionCreators';
import {Link, withRouter} from 'react-router-dom';
import Layout from '../../layout/Layout';
import constants from '../../constants';
import {useMount, useUnmount} from 'react-use';
import {extractBrandId} from '../../routes/routes';
import ArticleShow from '../../components/Articles/Show';
import SeoTags from '../../routes/SeoTags';
import {textKeysReplacement} from '../../tools/helpers';
import ArticlesList from '../../components/Articles/List';
import ProductsList from '../../components/ProductsList';

const ArticlePage = (props) => {
  const
    [currentPath, setCurrentPath] = useState(null),
    {is_mobile, current_city} = props.applicationState,
    articlePath = props.match.params.id,
    currentArticle = props.articlesState.currentArticle;

  useEffect(() => {
    if (articlePath === currentPath) return;
    props.articlesActions.resetArticleOffers();
    props.articlesActions.fetchResetOtherArticles;

    const articleId = extractBrandId(articlePath);
    props.articlesActions.fetchArticle(articleId);
    props.articlesActions.fetchArticleOffers(articleId);
    props.articlesActions.fetchOtherArticles(articleId);
    setCurrentPath(articlePath);
  }, [articlePath, props.articlesActions.fetchArticle]);

  useUnmount(() => {
    props.articlesActions.resetArticle();
    props.articlesActions.resetArticleOffers();
    props.articlesActions.resetOtherArticles();
  });

  return (
    <Layout
      className='article-page'
      breadcrumbs={[
        {label: 'Статьи', path: constants.ROUTES.REGIONAL_ARTICLES_PATH(props.applicationState.current_city.slug)},
        {label: currentArticle?.title}
      ]}
    >
      {
        currentArticle ?
          <SeoTags
            controller_action='articles#show'
            seo_context={{
              title: textKeysReplacement(currentArticle.seo_title, props.applicationState.default_seo_context) || currentArticle.title,
              description: textKeysReplacement(currentArticle.seo_description, props.applicationState.default_seo_context),
              keywords: textKeysReplacement(currentArticle.seo_keywords, props.applicationState.default_seo_context),
            }}
          />
          : null
      }
      <div className='container'>
        <section className='page-content-section'>
          <ArticleShow article={currentArticle} applicationState={props.applicationState} />
        </section>
        {
          props.articlesState.otherArticles?.length ?
            <section className='page-content-section'>
              <h3>
                Другие
              </h3>
              <ArticlesList
                collection={props.articlesState.otherArticles}
                linkHelper={constants.ROUTES.REGIONAL_ARTICLE_PATH}
                idKey='id_with_slug'
              />
            </section>
            : null
        }

        {
          props.articlesState.articleOffers?.length ?
            <section className='page-content-section'>
              <h3>
                Товары из статьи
              </h3>
              <ProductsList products={props.articlesState.articleOffers} colsCount={6} listClass={ is_mobile ? `mobile-inline` : ''} />
            </section>
            : null
        }

      </div>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      articlesActions: bindActionCreators(articlesActions, dispatch)
    };
  },

  mapStateToProps = ({articlesState, railsContext, applicationState}) => {
    return {
      applicationState,
      articlesState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default withRouter(compose(withConnect)(ArticlePage));
